/**
 * # Solutions
 *
 * A page with static text about product solutions offered by Softwear
 *
 * # Example
 * <pre>
 *   <solutions></solutions>
 * </pre>
 */
angular.module('gateApp').component('solutions', {
  template: require('./solutions.html').default,
  controller: class {
    private content: object;
    private segment: string;
    private currentLanguage$: any;

    constructor(
      private $routeParams: ng.route.IRouteParamsService,
      private $sce: ng.ISCEService,
      private language: any,
    ) {}

    $onInit() {
      this.currentLanguage$ = this.language.current$;

      this.segment = this.$routeParams.segment;

      this.content = {};

      if (this.segment) {
        switch (this.segment) {
          case 'retail':
            this.content['de-de'] = this.$sce.trustAsHtml(
              require('./retail/de-de.html').default,
            );
            this.content['en-gb'] = this.$sce.trustAsHtml(
              require('./retail/en-gb.html').default,
            );
            this.content['es-es'] = this.$sce.trustAsHtml(
              require('./retail/es-es.html').default,
            );
            this.content['fr-fr'] = this.$sce.trustAsHtml(
              require('./retail/fr-fr.html').default,
            );
            this.content['it-it'] = this.$sce.trustAsHtml(
              require('./retail/it-it.html').default,
            );
            this.content['nl-nl'] = this.$sce.trustAsHtml(
              require('./retail/nl-nl.html').default,
            );
            break;
          case 'wholesale':
            this.content['de-de'] = this.$sce.trustAsHtml(
              require('./wholesale/de-de.html').default,
            );
            this.content['en-gb'] = this.$sce.trustAsHtml(
              require('./wholesale/en-gb.html').default,
            );
            this.content['es-es'] = this.$sce.trustAsHtml(
              require('./wholesale/es-es.html').default,
            );
            this.content['fr-fr'] = this.$sce.trustAsHtml(
              require('./wholesale/fr-fr.html').default,
            );
            this.content['it-it'] = this.$sce.trustAsHtml(
              require('./wholesale/it-it.html').default,
            );
            this.content['nl-nl'] = this.$sce.trustAsHtml(
              require('./wholesale/nl-nl.html').default,
            );
            break;
        }
      }
    }
  },
});
